module.exports = __webpack_public_path__ + "img/80.14fc4cd5.jpg";